import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TerminalITSystemsIcon = createIcon({
    viewBox: '10 10 24 24',
    path: (
        <Path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M14.5 24.5H29.5V14.5H14.5V24.5ZM29.5 12H14.5C13.837 12 13.2011 12.2634 12.7322 12.7322C12.2634 13.2011 12 13.837 12 14.5V24.5C12 25.163 12.2634 25.7989 12.7322 26.2678C13.2011 26.7366 13.837 27 14.5 27H20.75V29.5H18.25C17.9185 29.5 17.6005 29.6317 17.3661 29.8661C17.1317 30.1005 17 30.4185 17 30.75C17 31.0815 17.1317 31.3995 17.3661 31.6339C17.6005 31.8683 17.9185 32 18.25 32H25.75C26.0815 32 26.3995 31.8683 26.6339 31.6339C26.8683 31.3995 27 31.0815 27 30.75C27 30.4185 26.8683 30.1005 26.6339 29.8661C26.3995 29.6317 26.0815 29.5 25.75 29.5H23.25V27H29.5C30.163 27 30.7989 26.7366 31.2678 26.2678C31.7366 25.7989 32 25.163 32 24.5V14.5C32 13.837 31.7366 13.2011 31.2678 12.7322C30.7989 12.2634 30.163 12 29.5 12Z'
            fill='currentColor'
        />
    ),
})

TerminalITSystemsIcon.displayName = 'TerminalITSystemsIcon'
